module.exports = __webpack_public_path__ + "static/media/Info.b21500a8.webp";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/home/Info.webp
// module id = 510
// module chunks = 4